import * as R from 'ramda'
import {
    call,
     reducer,
    loadStarted,
    loadEnded,
    loadSuccess,
    loadFailure,
    started,
    response,
    failure,
    reset
 } from '../../helpers/api/meta'
import { errorToBeAdded } from '../../reducers/errorReducer';

import { getCourseModule, postCourseModule,getCourseModuleWithID, patchCourseModule, deleteModule } from '../../helpers/api/api';

export const GET_COURSE_MODULE = 'GET_COURSE_MODULE'
export const POST_COURSE_MODULE = 'POST_COURSE_MODULE';
export const POST_COURSE_ID_MODULE = 'POST_COURSE_ID_MODULE';
export const EDIT_COURSE_MODULE = 'EDIT_COURSE_MODULE';
export const callGetCourseModule = (inputs) => {
    const meta = {
        endpoint: (params) => getCourseModule(params),
        inputs,
        action: GET_COURSE_MODULE,
        messages: {
            id: 'getCourseModule',
            failure: 'Could not get course module'
        }
    }
    return call(meta)
}

const initialState = {
    loading: false,
    modules: []
}

export const callResetCourseModule = () => (dispatch) => {
  dispatch(reset(GET_COURSE_MODULE)); 
  };

const saveCourseModule = (state, action) => {
    return R.assoc('modules', action.results, state);
}

const messages = {
    loadFailed: 'Could not load courses modules.',
}

export default reducer(initialState, GET_COURSE_MODULE, saveCourseModule, messages.loadFailed)

export const callAddCourseModule = body => (dispatch) => {
    dispatch(started(POST_COURSE_MODULE));
    return postCourseModule(body)
      .then((success) => {
        dispatch(response(POST_COURSE_MODULE));
        return success;
      })
      .catch((error) => {
        dispatch(failure(POST_COURSE_MODULE, error));
        throw error;
      });
  };

  
// export const callAddCourseWithoutIDModule = body => (dispatch) => {
//   dispatch(started(POST_COURSE_ID_MODULE));
//   return postCourseWithoutIDModule(body)
//     .then((success) => {
//       dispatch(response(POST_COURSE_ID_MODULE));
//       return success;
//     })
//     .catch((error) => {
//       dispatch(failure(POST_COURSE_ID_MODULE, error));
//       throw error;
//     });
// };

  
  
  export const callEditCouserModule = body => (dispatch) => {
    dispatch(started(EDIT_COURSE_MODULE));
    return patchCourseModule(body)
      .then((success) => {
        dispatch(response(EDIT_COURSE_MODULE));
        return success;
      })
      .catch((error) => {
        dispatch(failure(EDIT_COURSE_MODULE, error));
        throw error;
      });
  };


  export const callGetCouserModuleWithID = body => (dispatch) => {
    dispatch(started(GET_COURSE_MODULE));
    return getCourseModuleWithID(body)
      .then((success) => {
        dispatch(response(GET_COURSE_MODULE));
        return success;
      })
      .catch((error) => {
        dispatch(failure(GET_COURSE_MODULE, error));
        throw error;
      });
  };

  export const DELETE_COURSE_MODULE = 'DELETE_COURSE_MODULE';
const errorMsg = 'Unable to delete Course Module';

export const deleteCouserModuleRequest = (id) => (dispatch) => {
    dispatch(loadStarted(DELETE_COURSE_MODULE));
    return deleteModule(id)
        .then((response) => {
            dispatch(loadEnded(DELETE_COURSE_MODULE));
            dispatch(loadSuccess(DELETE_COURSE_MODULE));
            return response;
        })
        .catch((error) => {
            dispatch(loadEnded(DELETE_COURSE_MODULE));
            dispatch(loadFailure(DELETE_COURSE_MODULE, error));
            dispatch(errorToBeAdded(error, 'deleteModule', errorMsg));
        });
};
  


